import React from 'react';

import { useBooleanState } from '@lumapps/lumx-hooks/hooks/useBooleanState';
import { useLazyLoadingProgress } from '@lumapps/lumx-suspense/hooks/useLazyLoadingProgress';
import type { ExtensionProps } from '@lumapps/marketplace/legacy-types';

export function useLoadExtensionsShareDialog() {
    const [isShareToExtensionDialog, openShareToExtensionDialog, closeShareToExtensionDialog] = useBooleanState(false);
    const [extensionIsLoaded, setExtensionIsLoaded] = React.useState(false);
    const { onComponentLoaded: onExtensionLoaded } = useLazyLoadingProgress(extensionIsLoaded);
    const [currentExtension, setCurrentExtension] = React.useState<null | ExtensionProps>(null);
    const handleOpenExtension = React.useCallback(
        (extension: ExtensionProps) => {
            setCurrentExtension(extension);
            setExtensionIsLoaded(true);
            openShareToExtensionDialog();
        },
        [openShareToExtensionDialog],
    );
    return {
        extensionIsLoaded,
        onExtensionLoaded,
        currentExtension,
        handleOpenExtension,
        isShareToExtensionDialog,
        openShareToExtensionDialog,
        closeShareToExtensionDialog,
    };
}
